import React from "react";
import { Checkbox } from "material-ui";

const MailingListPreferenceField = (
  { value, onChange, ...rest },
  { tenant }
) => {
  return (
    <Checkbox
      iconStyle={{ alignSelf: "center" }}
      labelStyle={{ fontSize: "0.8em", lineHeight: "14px" }}
      label={`Please add me to the ${tenant.display_name} mailing list to receive updates on festival news, year-round events, and opportunities.`}
      checked={value}
      onCheck={(e, checked) => onChange(!value)}
      {...rest}
    />
  );
};

MailingListPreferenceField.contextTypes = {
  tenant: React.PropTypes.object
};

export default MailingListPreferenceField;



// WEBPACK FOOTER //
// ./src/app/components/partials/mailing-list-preference-field.jsx